var map = {
	"./Mandatory Disclosure Details _ SARAS 5.0.pdf": 699,
	"./academic.pdf": 7538,
	"./affiliation.pdf": 5179,
	"./building.pdf": 7191,
	"./fee.pdf": 3217,
	"./firecertificate.pdf": 2512,
	"./noc.pdf": 7377,
	"./pta.pdf": 1612,
	"./result.pdf": 32,
	"./school infra.pdf": 7281,
	"./selfcertificate.pdf": 8510,
	"./smc.pdf": 6666,
	"./teaching staff.pdf": 1492,
	"./trust.pdf": 7583,
	"./waterhealth.pdf": 3230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7435;